import React from 'react';
import { ScrapeJob } from '../../types';
import { CheckCircle2, AlertCircle, RefreshCw, X } from 'lucide-react';

interface JobProgressToastProps {
  jobs: ScrapeJob[];
  onDismiss: (jobId: string) => void;
}

export const JobProgressToast: React.FC<JobProgressToastProps> = ({ jobs, onDismiss }) => {
  if (jobs.length === 0) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 space-y-2 max-w-sm w-full">
      {jobs.map((job) => {
        const isDone = job.status === 'completed' || job.status === 'no_change';
        const isFailed = job.status === 'failed';

        return (
          <div
            key={job.jobId}
            className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-xl p-4 flex items-start gap-3 transition-all animate-fadeIn"
          >
            <div className="mt-0.5">
              {isDone ? (
                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
              ) : isFailed ? (
                <AlertCircle className="w-5 h-5 text-rose-500" />
              ) : (
                <RefreshCw className="w-5 h-5 text-indigo-500 animate-spin" />
              )}
            </div>

            <div className="flex-1 text-xs">
              <div className="font-bold text-slate-900 dark:text-white flex items-center justify-between">
                <span>{job.companyId.toUpperCase()} Ingestion</span>
                <span className="font-mono text-[10px] text-slate-400">{job.progress}%</span>
              </div>
              <p className="text-slate-600 dark:text-slate-300 mt-0.5 leading-tight">
                {job.message || 'Scraping and analyzing policy document...'}
              </p>
            </div>

            <button
              onClick={() => onDismiss(job.jobId)}
              className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-0.5"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
